export class Curso {
    constructor(
      public id?: string,
      public descripcion?: string,
      public isActive: number = 1
    ) {
    }
  }